import {type ISearchComboboxOptionDomProps, type SearchComboboxMode, SearchComboboxSpinner} from "@pg-design/search-combobox-module";
import {PRICES_SEARCH_TEST_IDS} from "@pg-mono/test-ids";

import type {IPricesSearchNearbyItem} from "../../types/IPricesSearchModel";
import {PricesSearchRow} from "./PricesSearchRow";

interface IProps {
    item: IPricesSearchNearbyItem;
    optionProps: ISearchComboboxOptionDomProps;
    mode: SearchComboboxMode;
}

/**
 * "Ceny w mojej okolicy": the location glyph, the state in the subtitle ("Na podstawie
 * lokalizacji urządzenia", "Nie udało się ustalić lokalizacji", "Nie mamy jeszcze cen dla …") and a spinner in the
 * metrics column while the device is being located. The browser asks for the permission only after it is selected.
 * When the site is blocked from location the row is inert and the subtitle, wrapped in full, says how to allow it.
 */
export const PricesSearchNearbyRow = (props: IProps) => {
    const {item, optionProps, mode} = props;

    return (
        <PricesSearchRow
            item={item}
            optionProps={optionProps}
            mode={mode}
            meta={item.state.status === "locating" ? <SearchComboboxSpinner size={16} /> : undefined}
            isSubtitleWrapped={item.state.status === "blocked"}
            dataTestId={PRICES_SEARCH_TEST_IDS.NEARBY}
        />
    );
};
import {type ISearchComboboxOptionDomProps, type SearchComboboxMode, SearchComboboxSpinner} from "@pg-design/search-combobox-module";
import {PRICES_SEARCH_TEST_IDS} from "@pg-mono/test-ids";

import type {IPricesSearchNearbyItem} from "../../types/IPricesSearchModel";
import {PricesSearchRow} from "./PricesSearchRow";

interface IProps {
    item: IPricesSearchNearbyItem;
    optionProps: ISearchComboboxOptionDomProps;
    mode: SearchComboboxMode;
}

/**
 * "Ceny w mojej okolicy": the location glyph, the state in the subtitle ("Na podstawie
 * lokalizacji urządzenia", "Nie udało się ustalić lokalizacji", "Nie mamy jeszcze cen dla …") and a spinner in the
 * metrics column while the device is being located. The browser asks for the permission only after it is selected.
 * When the site is blocked from location the row is inert and the subtitle, wrapped in full, says how to allow it.
 */
export const PricesSearchNearbyRow = (props: IProps) => {
    const {item, optionProps, mode} = props;

    return (
        <PricesSearchRow
            item={item}
            optionProps={optionProps}
            mode={mode}
            meta={item.state.status === "locating" ? <SearchComboboxSpinner size={16} /> : undefined}
            isSubtitleWrapped={item.state.status === "blocked"}
            dataTestId={PRICES_SEARCH_TEST_IDS.NEARBY}
        />
    );
};
